import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, MenuItem, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import Header from '../../../components/Header'
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { addDispatchSuggestion, deleteDispatchDetails, editDispatchSuggestion, getDispatchSuggestion, getSuggestionCategoty, getSuggestionProduct, getSuggestionSubCategoty, viewDispatchSuggestion } from '../../../redux/slice/dispatchsuggestion.slice';
import { useFormik } from 'formik';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { getProcesskitproduct } from '../../../redux/slice/dispatchProcess.slice';

const validationSchemas =
    Yup.object({
        ProjectName: Yup.string().required("Please enter Name"),
        DispatchDetails: Yup.array().of(
            Yup.object({
                DispatchCatogory: Yup.string().required('Catogory is required'),
                DispatchSubCatogory: Yup.string().required('Sub Catogory is required'),
                DispatchProductName: Yup.string().required('Product Name is required'),
                DispatchDiscription: Yup.string(),
                // DispatchUnit: Yup.string().required("Unit Of Measurement is required"),
                // DispatchQty: Yup.string().required('Qty is required'),
            })
        )
    });

const initialValues = {
    ProjectName: '',
    DispatchDetails: [{
        DispatchCatogory: '',
        DispatchSubCatogory: '',
        DispatchProductName: '',
        DispatchDiscription: '',
        DispatchUnit: '',
        DispatchQty: '1',
    }]
};

const AddDispatchSuggestion = () => {

    const { state } = useLocation();
    const id = state?._id;

    console.log("idddd", id);

    const [suggestiondata, setsuggestiondata] = useState(initialValues.DispatchDetails)
    const theme = useTheme();
    const dispatch = useDispatch();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const isMobile = useMediaQuery('(max-width:500px)');

    const navigate = useNavigate();
    const categories = useSelector(state => state.dispatchsuggestion.category);
    const subcategories = useSelector(state => state.dispatchsuggestion.subCategory);
    const productData = useSelector(state => state.dispatchsuggestion.products)
    const suggestionData = useSelector(state => state.dispatchsuggestion.dispatchsuggestion)
    const [filteredProducts, setFilteredProducts] = useState([]);

    const kitproductdata = useSelector(state => state.dispatchProcess.kitproduct)

    console.log("dede", kitproductdata);


    useEffect(() => {
        dispatch(getSuggestionCategoty())
        dispatch(getSuggestionSubCategoty())
        dispatch(getSuggestionProduct())
        dispatch(getProcesskitproduct())
    }, [])

    const kitCategoryId = categories?.find(cat => cat.categoryName === 'KitCategory')?._id;
    const kitSubCategoryId = subcategories?.find(sub => sub.subCategoryName === 'KitSubCategory')?._id;

    React.useEffect(() => {
        if (id) {
            dispatch(viewDispatchSuggestion(id)).then((response) => {
                if (response.payload) {
                    const dispatchData = response.payload;
                    console.log(dispatchData, "dispatchData");

                    setValues({
                        ...dispatchData,
                        DispatchDetails: [...dispatchData.DispatchDetails],
                    });

                    console.log("asas", values);

                    setsuggestiondata([...dispatchData.DispatchDetails]);

                    // const newFilteredProducts = dispatchData.DispatchDetails.map(detail => {
                    //     const productsForCategory = productData?.filter(product => product.mainCategoryData?.[0]?._id === detail.DispatchCatogory);
                    //     return productsForCategory;
                    // });
                    // setFilteredProducts(newFilteredProducts);

                    let newFilteredProducts = [];

                    let x = dispatchData.DispatchDetails.map((detail) => {
                        console.log("detail.DispatchCatogory", detail, kitCategoryId, kitproductdata);
                    
                        let kit = kitproductdata.find(s => s._id === detail.DispatchProductName);

                        if (kit) {
                            return [...kitproductdata];
                        }
                        // Filter main category products
                        const productsForCategory = productData?.filter(
                            (product) => product.mainCategoryData?.[0]?._id === detail.DispatchCatogory
                        );

                        return productsForCategory

                        // console.log(productsForCategory, "productsForCategory");
                    
                        // // Filter kit products for the category (need to match kitcategory and kitsubcategory here)
                        // const kitProductsForCategory = kitproductdata?.filter((kit) =>
                        //     kit.KitDetails.some((k) => k.KitCatogory === detail.DispatchCatogory)
                        // );
                        // console.log(kitProductsForCategory, "kitProductsForCategory");
                    
                        // // Add kit products at the beginning
                        // // if (kitProductsForCategory?.length > 0) {
                        // //     return kitProductsForCategory
                        // //     // newFilteredProducts.push(...kitProductsForCategory);
                        // // }
                    
                        // // Add other products in the next array index
                        // if (productsForCategory?.length > 0) {
                        //     return productsForCategory
                        //     // newFilteredProducts.push(...productsForCategory);
                        // } else {
                            
                        // }
                    });
                    
                    console.log(x, "final newFilteredProducts");
                    setFilteredProducts(x);
                    
                }
            }).catch(error => {
                console.error("Error fetching data:", error);
            });
        }
    }, [id, productData]);

    const handleSubmit = () => {
        const isValid = validationSchemas.isValidSync(values);
        if (!isValid) {

        } else {
            // const updatedData = submissionValues.DispatchDetails.map(item => ({
            //     ...item,
            //     DispatchQty: item.DispatchQty === "" ? "1" : item.DispatchQty
            //   }));

            // const submissionValues = {
            //     ...values,
            //     DispatchDetails: values.DispatchDetails.filter(detail => !detail.isDeleted),
            // };

            const submissionValues = {
                ...values,
                DispatchDetails: values.DispatchDetails
                  .filter(detail => !detail.isDeleted)
                  .map(detail => ({
                    ...detail,
                    DispatchQty: detail.DispatchQty === "" ? "1" : detail.DispatchQty
                  }))
              };

            

            // console.log("submissionValues", updatedData);
            // {
            //     "_id": "67a9f3493eb17f29254dada6",
            //     "ProjectName": "demosugg",
            //     "DispatchDetails": [
            //         {
            //             "DispatchCatogory": "67a9ab1bc260b6fac4de7a54",
            //             "DispatchSubCatogory": "67a9ab2cc260b6fac4de7a73",
            //             "DispatchProductName": "67a97b6934bb3b63965c1274",
            //             "DispatchDiscription": "",
            //             "DispatchUnit": "",
            //             "DispatchQty": "",
            //             "_id": "67a9f3493eb17f29254dada7"
            //         },
            //         {
            //             "DispatchCatogory": "6768f7cc0c4415c2184778d1",
            //             "DispatchSubCatogory": "6768f8100c4415c2184778f3",
            //             "DispatchProductName": "6768fa3f0c4415c21847797e",
            //             "DispatchDiscription": "Profix PVC Cable Tie 4.8 x 300 MM white/black",
            //             "DispatchUnit": "Nos",
            //             "DispatchQty": "2",
            //             "_id": "67a9f3493eb17f29254dada8"
            //         },
            //         {
            //             "DispatchCatogory": "6749c8bf864db29472435052",
            //             "DispatchSubCatogory": "675fbf76f25a5f601ceb3ccc",
            //             "DispatchProductName": "675fd5d3f25a5f601ceb3eb5",
            //             "DispatchDiscription": "Solax 5 KW 2 MPPT\n",
            //             "DispatchUnit": "Nos",
            //             "DispatchQty": "1",
            //             "_id": "67aad1abbc6a48ab0073286d"
            //         }
            //     ]
            // }
            
            if (id) {

                delete submissionValues.isActive;
                delete submissionValues.createdAt;
                delete submissionValues.updatedAt;

                Promise.all(itemsToDelete.map(itemId =>
                    dispatch(deleteDispatchDetails(itemId))
                )).then(() => {

                    dispatch(editDispatchSuggestion({
                        id: values._id,
                        ...submissionValues
                    })).then(() => {
                        dispatch(getDispatchSuggestion());
                        navigate('/admin/dispatch-suggestion');
                        setItemsToDelete([]);
                    });
                });
            } else {

                dispatch(addDispatchSuggestion({ data: submissionValues })).then(() => {
                    dispatch(getDispatchSuggestion());
                    navigate('/admin/dispatch-suggestion');
                });
            }
            resetForm();
        }
    };

    const handleAddDispatch = () => {
        const newDispatch = {
            DispatchCatogory: '',
            DispatchSubCatogory: '',
            DispatchProductName: '',
            DispatchDiscription: '',
            DispatchUnit: '',
            DispatchQty: '',
        };

        setsuggestiondata([...suggestiondata, newDispatch]);
        setFieldValue('DispatchDetails', [...values.DispatchDetails, newDispatch]);
    }

    const formik = useFormik({
        initialValues: { ...initialValues, DispatchDetails: suggestiondata },
        validationSchema: validationSchemas,
        onSubmit: handleSubmit,
    });

    const {
        handleBlur,
        handleChange,
        values,
        touched,
        errors,
        setFieldValue,
        resetForm,
        setValues,
        setFieldTouched
    } = formik

    console.log("eeeerr", errors);


    const handleCategoryChange = (index, value) => {
        setFieldValue(`DispatchDetails[${index}].DispatchCatogory`, value);
        setFieldValue(`DispatchDetails[${index}].DispatchSubCatogory`, "");
        setFieldValue(`DispatchDetails[${index}].DispatchProductName`, "");

        const productsForCategory = productData?.filter(product => product.mainCategoryData?.[0]?._id === value);
        setFilteredProducts(prev => {
            const newFilteredProducts = [...prev];
            newFilteredProducts[index] = productsForCategory || [];
            return newFilteredProducts;
        });
    };

    const handleSubCategoryChange = (index, value) => {
        setFieldValue(`DispatchDetails[${index}].DispatchSubCatogory`, value);

        console.log(productData);

        console.log(index, value);

        let productsForSubcategory = [];

        if (value === kitSubCategoryId) {
            productsForSubcategory = [...kitproductdata]
        } else {
            productsForSubcategory = [...productData?.filter(product => product.subCategoryData?.[0]?._id === value)];
        }


        setFilteredProducts(prev => {
            const newFilteredProducts = [...prev];
            newFilteredProducts[index] = productsForSubcategory || [];
            return newFilteredProducts;
        });


    };

    const handleProductChange = (index, value) => {
        setFieldValue(`DispatchDetails[${index}].DispatchProductName`, value);
        const product = productData?.find(product => product._id === value);
        if (product) {
            setFieldValue(`DispatchDetails[${index}].DispatchDiscription`, product.Desacription);
            setFieldValue(`DispatchDetails[${index}].DispatchUnit`, product.unitOfMeasurement);
        }
    }

    const [itemsToDelete, setItemsToDelete] = useState([]);

    const handleAddKit1 = (index) => {
        const oldDispatchDetails = [...values.DispatchDetails];
        const newDispatch = {
            DispatchCatogory: '',
            DispatchSubCatogory: '',
            DispatchProductName: '',
            DispatchDiscription: '',
            DispatchUnit: '',
            DispatchQty: '',
        };

        oldDispatchDetails.splice(index + 1, 0, newDispatch);
        const productsForCategory = productData;
        const filter = [...filteredProducts];
        filter.splice(index + 1, 0, productData)
        setFilteredProducts(filter);

        formik.setFieldValue('DispatchDetails', oldDispatchDetails);

        formik.setTouched({
            DispatchDetails: oldDispatchDetails.map((_, i) => ({
                DispatchCatogory: i === index + 1 ? false : touched.DispatchDetails?.[i]?.DispatchCatogory,
                DispatchSubCatogory: i === index + 1 ? false : touched.DispatchDetails?.[i]?.DispatchSubCatogory,
                DispatchProductName: i === index + 1 ? false : touched.DispatchDetails?.[i]?.DispatchProductName,
                DispatchDiscription: i === index + 1 ? false : touched.DispatchDetails?.[i]?.DispatchDiscription,
                DispatchUnit: i === index + 1 ? false : touched.DispatchDetails?.[i]?.DispatchUnit,
                DispatchQty: i === index + 1 ? false : touched.DispatchDetails?.[i]?.DispatchQty,
            })),
        });
    };

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    const handleDeleteKit = (index) => {
        setDeleteIndex(index);
        setOpenDeleteDialog(true);
    };

    const confirmDelete = () => {
        const index = deleteIndex;
        const updatedDispatchDetails = [...values.DispatchDetails];

        updatedDispatchDetails[index] = { ...updatedDispatchDetails[index], isDeleted: true };
        setsuggestiondata(updatedDispatchDetails);
        formik.setFieldValue('DispatchDetails', updatedDispatchDetails);

        setDeleteIndex(null);
        setOpenDeleteDialog(false);
    };

    const cancelDelete = () => {
        setDeleteIndex(null);
        setOpenDeleteDialog(false);
    };

    // const categories = useSelector(state => state.dispatchProcess.category)
    // const subcategories = useSelector(state => state.dispatchProcess.subCategory)

    

    console.log(kitCategoryId, kitSubCategoryId);

    console.log(filteredProducts, "filteredProductsfilteredProductsss");


    return (
        <Box m="2px">
            {id ? (
                <Header
                    title="UPDATE DISPATCH SUGGESTION"
                    subtitle="Update Your Dispatch Suggestion Here"
                />
            ) : (
                <Header
                    title="ADD DISPATCH SUGGESTION"
                    subtitle="Manage Your Dispatch Suggestion Here"
                />
            )}

            <form onSubmit={handleSubmit} enctype="multipart/form-data">
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
                    <Box
                        display="grid"
                        gap="30px"
                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                        }}>
                        <FormControl variant="filled" sx={{ minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Dispatch Suggestion Name :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.ProjectName}
                                name="ProjectName"
                                error={!!touched.ProjectName && !!errors.ProjectName}
                                helperText={touched.ProjectName && errors.ProjectName}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                    </Box>

                    <Box sx={{ overflowX: "auto", width: "100%" }}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow >
                                        <TableCell sx={{ width: "70px", fontSize: "14px" }} > Sr No</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Category</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Sub Category</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Product Name</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Discription</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Unit of Measurement</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Quantity</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {values.DispatchDetails &&
                                        values.DispatchDetails.map((suggestion, index) => !suggestion.isDeleted && (
                                            <TableRow key={index}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "180px",
                                                                sm: "200px",
                                                                md: "260px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {
                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`DispatchDetails.${index}.DispatchCatogory`}
                                                        onChange={e => handleCategoryChange(index, e.target.value)}
                                                        value={values.DispatchDetails?.[index]?.DispatchCatogory || ''}
                                                        error={!!touched.DispatchDetails?.[index]?.DispatchCatogory && !!errors.DispatchDetails?.[index]?.DispatchCatogory}
                                                        helperText={touched.DispatchDetails?.[index]?.DispatchCatogory && errors.DispatchDetails?.[index]?.DispatchCatogory}
                                                        InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                                                    >
                                                        {categories?.map((category) => (
                                                            <MenuItem key={category._id} value={category._id}>
                                                                {category.categoryName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </TableCell>
                                                {/* Sub Category */}
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        // label="Sub Category :"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "180px",
                                                                sm: "200px",
                                                                md: "260px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`DispatchDetails.${index}.DispatchSubCatogory`}
                                                        onChange={e => handleSubCategoryChange(index, e.target.value)}
                                                        value={values.DispatchDetails?.[index]?.DispatchSubCatogory || ''}
                                                        error={!!touched.DispatchDetails?.[index]?.DispatchSubCatogory && !!errors.DispatchDetails?.[index]?.DispatchSubCatogory}
                                                        helperText={touched.DispatchDetails?.[index]?.DispatchSubCatogory && errors.DispatchDetails?.[index]?.DispatchSubCatogory}
                                                        InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                                                    >
                                                        {subcategories
                                                            ?.filter(subcategory => subcategory.categoryData?.[0]?._id === values.DispatchDetails?.[index]?.DispatchCatogory)
                                                            .map((subcategory) => (
                                                                <MenuItem key={subcategory._id} value={subcategory._id}>
                                                                    {subcategory.subCategoryName}
                                                                </MenuItem>
                                                            ))}
                                                    </TextField>
                                                </TableCell>

                                                {/* Product Name */}
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        // label="Product Name :"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "180px",
                                                                sm: "200px",
                                                                md: "260px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`DispatchDetails.${index}.DispatchProductName`}
                                                        onChange={e => handleProductChange(index, e.target.value)}
                                                        value={values.DispatchDetails?.[index]?.DispatchProductName || ''}
                                                        error={!!touched.DispatchDetails?.[index]?.DispatchProductName && !!errors.DispatchDetails?.[index]?.DispatchProductName}
                                                        helperText={touched.DispatchDetails?.[index]?.DispatchProductName && errors.DispatchDetails?.[index]?.DispatchProductName}
                                                        InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                                                    >
                                                        {filteredProducts[index]?.map((product) => (
                                                            <MenuItem key={product._id} value={product._id}>
                                                                {product.productName ? product.productName : product.KitName}
                                                            </MenuItem>
                                                        ))}

{/* {Array.isArray(filteredProducts[index]) &&
    filteredProducts[index].map((product) => {
        console.log(product, "productproduct");
        
        return (
            <MenuItem key={product._id} value={product._id}>
                {product.productName ? product.productName : product.KitName}
            </MenuItem>
        );
    })} */}

                                                    </TextField>
                                                </TableCell>

                                                {/* Description */}
                                                {
                                                    values.DispatchDetails?.[index]?.DispatchCatogory === kitCategoryId &&
                                                        values.DispatchDetails?.[index]?.DispatchSubCatogory === kitSubCategoryId ? '' : <TableCell sx={{ width: '10px' }}>
                                                        <TextField
                                                            sx={{
                                                                width: {
                                                                    xs: "180px",
                                                                    sm: "200px",
                                                                    md: "260px",
                                                                },
                                                                height: '40px',
                                                                "& .MuiInputBase-root": {

                                                                    fontSize: "0.8rem",
                                                                    height: "40px",
                                                                },
                                                                "& .MuiInputBase-input": {
                                                                    padding: "0 12px",
                                                                    height: "40px",
                                                                    lineHeight: "40px",
                                                                },
                                                            }}
                                                            variant="filled"
                                                            type="text"
                                                            // label="Description :"
                                                            onBlur={handleBlur}
                                                            onChange={e => setFieldValue(`DispatchDetails[${index}].DispatchDiscription`, e.target.value)}
                                                            value={values.DispatchDetails?.[index]?.DispatchDiscription || ''}
                                                            name={`DispatchDetails.${index}.DispatchDiscription`}
                                                            error={!!touched.DispatchDetails?.[index]?.DispatchDiscription && !!errors.DispatchDetails?.[index]?.DispatchDiscription}
                                                            helperText={touched.DispatchDetails?.[index]?.DispatchDiscription && errors.DispatchDetails?.[index]?.DispatchDiscription}
                                                            InputProps={{ readOnly: true }}
                                                        />
                                                    </TableCell>
                                                }


                                                {/* Unit of Measurement */}
                                                {
                                                    values.DispatchDetails?.[index]?.DispatchCatogory === kitCategoryId &&
                                                        values.DispatchDetails?.[index]?.DispatchSubCatogory === kitSubCategoryId ? '' : <TableCell sx={{ width: '10px' }}>
                                                        <TextField
                                                            sx={{
                                                                width: {
                                                                    xs: "80px",
                                                                    sm: "80px",
                                                                    md: "80px",
                                                                },
                                                                height: '40px',
                                                                "& .MuiInputBase-root": {

                                                                    fontSize: "0.8rem",
                                                                    height: "40px",
                                                                },
                                                                "& .MuiInputBase-input": {
                                                                    padding: "0 12px",
                                                                    height: "40px",
                                                                    lineHeight: "40px",
                                                                },
                                                            }}
                                                            variant="filled"
                                                            type="text"
                                                            // label="Unit Of Measurement :"
                                                            onBlur={handleBlur}
                                                            onChange={e => setFieldValue(`DispatchDetails[${index}].DispatchUnit`, e.target.value)}
                                                            value={values.DispatchDetails?.[index]?.DispatchUnit || ''}
                                                            name={`DispatchDetails.${index}.DispatchUnit`}
                                                            error={!!touched.DispatchDetails?.[index]?.DispatchUnit && !!errors.DispatchDetails?.[index]?.DispatchUnit}
                                                            helperText={touched.DispatchDetails?.[index]?.DispatchUnit && errors.DispatchDetails?.[index]?.DispatchUnit}
                                                            InputProps={{ readOnly: true }}
                                                        />
                                                    </TableCell>
                                                }


                                                {/* Quantity */}
                                                {
                                                    values.DispatchDetails?.[index]?.DispatchCatogory === kitCategoryId &&
                                                        values.DispatchDetails?.[index]?.DispatchSubCatogory === kitSubCategoryId ? '' : <TableCell sx={{ width: '10px' }}>
                                                        <TextField
                                                            sx={{
                                                                width: {
                                                                    xs: "80px",
                                                                    sm: "80px",
                                                                    md: "80px",
                                                                },
                                                                height: '40px',
                                                                "& .MuiInputBase-root": {

                                                                    fontSize: "0.8rem",
                                                                    height: "40px",
                                                                },
                                                                "& .MuiInputBase-input": {
                                                                    padding: "0 12px",
                                                                    height: "40px",
                                                                    lineHeight: "40px",
                                                                },
                                                            }}
                                                            variant="filled"
                                                            type="text"
                                                            // label="Quantity :"
                                                            onBlur={handleBlur}
                                                            onChange={e => setFieldValue(`DispatchDetails[${index}].DispatchQty`, e.target.value)}
                                                            value={values.DispatchDetails?.[index]?.DispatchQty || ''}
                                                            name={`DispatchDetails.${index}.DispatchQty`}
                                                            error={!!touched.DispatchDetails?.[index]?.DispatchQty && !!errors.DispatchDetails?.[index]?.DispatchQty}
                                                            helperText={touched.DispatchDetails?.[index]?.DispatchQty && errors.DispatchDetails?.[index]?.DispatchQty}

                                                        />
                                                    </TableCell>
                                                }

                                                <TableCell>
                                                    <Stack spacing={2} direction="row">
                                                        <Button
                                                            variant="contained"
                                                            color="success"
                                                            onClick={() => handleAddKit1(index)}
                                                            sx={{
                                                                width: "35px",
                                                                height: "35px",
                                                                minWidth: "20px",
                                                                padding: "0",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <AddIcon sx={{ fontSize: "16px" }} />
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="error"
                                                            onClick={() => handleDeleteKit(index)}
                                                            sx={{
                                                                width: "35px",
                                                                height: "35px",
                                                                minWidth: "20px",
                                                                padding: "0",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <DeleteIcon sx={{ fontSize: "16px" }} />
                                                        </Button>
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    <Dialog
                        open={openDeleteDialog}
                        onClose={cancelDelete}
                        aria-labelledby="delete-confirmation-dialog-title"
                        aria-describedby="delete-confirmation-dialog-description"
                    >
                        <DialogTitle id="delete-confirmation-dialog-title">
                            Confirm Delete
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="delete-confirmation-dialog-description">
                                Are you sure you want to delete this item? This action cannot be undone.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={cancelDelete} sx={{ color: theme.palette.text.primary }}>
                                Cancel
                            </Button>
                            <Button onClick={confirmDelete} color="error" autoFocus>
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <Box display="flex" justifyContent="flex-end" m={1}>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={handleAddDispatch}
                        >
                            Add Dispatch Suggestion
                        </Button>
                    </Box>
                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                onClick={handleSubmit}
                            >
                                {id ? 'Update' : 'Submit'}
                            </Button>
                        </Stack>
                    </FormControl>
                </Stack>
            </form>
        </Box>
    )
}

export default AddDispatchSuggestion;
